// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__2rJx8","pagination-next":"Pagination_pagination-next__iFzCk"};